<template>
  <Card class="card px-1 mt-3 border-surface-200 dark:border-surface-600 border dark:bg-surface-800! h-fit w-full my-auto" pt:content:class="p-0!">
    <template #content>
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-1">
          <label class="font-bold">Loan Amount</label>
          <InputGroup>
            <InputNumber
              v-model="loan"
              mode="currency"
              currency="USD"
              locale="en-US"
              input-class="rounded-l-lg!"
              :min="0.0"
              :max="availableLoan"
              :allowEmpty="false"
            ></InputNumber>
            <Button label="Max" @click="maxLoanAmount" />
          </InputGroup>
          <span class="text-xs"> Available {{ formatCurrency(availableLoan) }} </span>
        </div>
        <div class="flex flex-col gap-1">
          <label class="font-bold">Equity Amount</label>
          <InputGroup>
            <InputNumber
              v-model="equity"
              mode="currency"
              currency="USD"
              locale="en-US"
              input-class="rounded-l-lg!"
              :min="0.0"
              :max="availableEquity"
              :allowEmpty="false"
            ></InputNumber>
            <Button label="Max" @click="maxEquityAmount" />
          </InputGroup>
          <span class="text-xs"> Available {{ formatCurrency(availableEquity) }} </span>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex justify-end gap-2 mt-4">
        <Button label="Pay" @click="payDefaultPayee" />
        <Button label="Cancel" severity="surface" @click="$emit('cancelled')" />
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { formatCurrency } from "@/services/Utility";
import type { Project } from "@/types/Projects";

const emit = defineEmits<{
  paid: [];
  cancelled: [];
}>();

const loan = ref<number>(0);
const equity = ref<number>(0);

interface Props {
  project: Project;
  availableLoan?: number;
  availableEquity?: number;
}

const props = withDefaults(defineProps<Props>(), {
  availableLoan: 0,
  availableEquity: 0,
});

const maxLoanAmount = (): void => {
  loan.value = props.availableLoan;
};

const maxEquityAmount = () => {
  equity.value = props.availableEquity;
};

const payDefaultPayee = (): void => {
  let data = new FormData();
  data.append("loan", loan.value + "");
  data.append("equity", equity.value + "");
  data.append("projectId", props.project.projectInfo.projectId);
  data.append("drawNumber", props.project.projectDrawInfo.drawNumber + "");

  axios
    .post("/ledger/paydefault", data)
    .then((response) => {
      handleApiResponse(
        response,
        (data: any) => {
          success("Success", "New payment(s) available to process");
          emit("paid");
        },
        (errors: ApiError[]) => {
          error("Error occurred", errors[0].message);
        }
      );
    })
    .catch((e) => errorApi(e));
};
</script>
